import _L from "../../../util/Labels";
import JSZip from "jszip";
import saveAs from "file-saver";
import { _BoletaPDFV3 } from "./Boletas/BoletaV3";
import { _BoletaPDFV4 } from "./Boletas/BoletaV4";
import { _DiccMateriasV2 } from "../../../data/modulo/MateriaV2";
import { _LOCALDATA_GetGruposHorariosDeAlumno, _LOCALDATA_GetTutoresDeAlumno, _SvAlumnoNuevoExpedienteBoleta } from "../../../data/modulo/Alumno";
import { _ModalServiceIteratorBasic } from "../../controlD3/ModalThings/ModalServiceIteratorBasic";
import { _ModalToAProccess } from "../../controlD3/ModalThings/ModalToAProccess";
import { _SvNoticiaNueva, IMapSendCincularItems } from "../../../data/modulo/Noticia";
import { ascending, descending, group } from "d3-array";
import { Button } from "../../controlD3/Button";
import { DataModuloMain } from "../../../data/ModuloMain";
import { DataUtil } from "../../../data/util/Util";
import { DataUtilAlertBot } from "../../../data/util/AlertBot";
import { Entidad } from "../../../data/Entidad";
import { HTMLTooltipComponent, TooltipElementObservedConfig } from "../../controlWC/TooltipComponent";
import { List } from "../../controlD3/List";
import { ModalThingsUtil } from "../../controlD3/ModalThings/Utils";
import { NotificacionV2 } from "../../controlD3/NotificacionV2";
import { PDFThings } from "../../controlD3/PDFBuilder";
import { UIUtilGeneral } from "../../util/Util";
import { UIUtilIconResources } from "../../util/IconResourses";
import { UIUtilTime } from "../../util/Time";
import { UIUtilViewCalificacion } from "../Calificacion";
import BoletasGeneradasInfo = Entidad.BoletasGeneradasInfo;
import CPDFStatus = UIUtilViewCalificacion.CPDFStatus;
import CTipoEvaluacion = Entidad.CTipoEvaluacion;
import IAlumnoBoleta = UIUtilViewCalificacion.IAlumnoBoleta;
import IAlumnoBoletaFinal = UIUtilViewCalificacion.IAlumnoBoletaFinal;
import IAsignacionInfo = Entidad.IAsignacionInfo;
import IBoletaConfigV2 = UIUtilViewCalificacion.IBoletaConfigV2;
import ICalificacionInfoAPeriods = UIUtilViewCalificacion.ICalificacionInfoAPeriods;
import ICalificacionInfoV2 = UIUtilViewCalificacion.ICalificacionInfoV2;
import IEvaluacionesV2 = UIUtilViewCalificacion.IEvaluacionesV2;
import IEvaluacionInfo = UIUtilViewCalificacion.IEvaluacionInfo;
import IMateriaEvaluacion = UIUtilViewCalificacion.IMateriaEvaluacion;
import IModalThings = ModalThingsUtil.IModalThings;
import ItemAlumno = UIUtilViewCalificacion.ItemAlumno;
import { _GetBoletaFilteredGrades, _GetBoletaFilteredGroups, _GetBoletaGrados, _GetBoletaGroupsName, _GetBoletaNiveles, _GetStudentGroupsName, _IsCurrentCicloEscolar, _ModalEditionBoletaV3, _ModalEditionBoletaV4, _ModalEditionBoletaV4_1, _ReportCardInfoEdition } from "./Util";
import { _ModalInfoDataList } from "../../controlD3/ModalThings/ModalInfoDataList";
import { _BoletaPDFV4_1 } from "./Boletas/BoletaV4_1";

interface IGenerateBoletasConfig {
    StudentsBoletasData: IAlumnoBoleta[];
    AssignmentsInfo: IAsignacionInfo[];
    onClose?: () => void;
}

interface ISubjectAssignmentsEvals {
    IdMateria: number;
    TipoEval: CTipoEvaluacion;
    TieneCriterios: boolean;
    Evaluaciones: UIUtilViewCalificacion.IEvaluacionesV2[];
}

class BoletasGeneratorManager {
    private readonly config: IGenerateBoletasConfig;
    private readonly finalStudentsData: IAlumnoBoletaFinal[];
    private readonly studentsBoletasInfoMap: Map<number, IAlumnoBoletaFinal>;
    private readonly studentsDataList: ItemAlumno[];
    private readonly assignmentsInfoMap: Map<number, IAsignacionInfo>;

    private ctrlList: List<ItemAlumno>;
    private pdfViewerContainer: TSelectionHTML<"div">;
    private modal: IModalThings;

    constructor(config: IGenerateBoletasConfig) {
        this.config = config;
        this.finalStudentsData = this.PrepareFinalStudentsData();
        this.studentsBoletasInfoMap = new Map<number, IAlumnoBoletaFinal>();
        this.studentsDataList = this.PrepareStudentsDataList();
        this.assignmentsInfoMap = new Map<number, IAsignacionInfo>(this.config.AssignmentsInfo.map(d => ([d.IdAsignacion, d])));
    }

    private PrepareFinalStudentsData(): IAlumnoBoletaFinal[] {
        return this.config.StudentsBoletasData.map<IAlumnoBoletaFinal>(studentBoletaData => {
            const { Alumno, CicloEscolar, Comentario, InfoExtra, Inasistencias, BoletasGeneradasEnCiclo, BoletaTemplateCfg } = studentBoletaData;
            const IsCurrentCicloEscolar = _IsCurrentCicloEscolar(CicloEscolar);

            const [materiaCalificaciones, idsEvaluaciones, boletaComentariosTeachers] = UIUtilViewCalificacion.ProcesaBoletaEvaluacionesInit(studentBoletaData.Evaluaciones);
            const studentTutorsMap = _LOCALDATA_GetTutoresDeAlumno(Alumno.IdChild);
            const tutorsNamesArr: string[] = Array.from(studentTutorsMap.values()).map(d => d.NombreCompleto);

            const subjectsTeachersRel = UIUtilViewCalificacion.GetSubjectTeachersRel(materiaCalificaciones, studentBoletaData.BoletasGeneradasEnCiclo);
            const groupsIdsInReportCard = UIUtilViewCalificacion.GetGroupsIdsInCurrentReportCard(materiaCalificaciones);

            return {
                Alumno: Alumno,
                CicloEscolar: CicloEscolar,
                CalificacionesFinal: materiaCalificaciones,
                IdsAllEvals: idsEvaluaciones,
                Comentario: Comentario,
                InfoExtra: InfoExtra,
                Inasistencias: Inasistencias,
                BoletasGeneradasEnCiclo: BoletasGeneradasEnCiclo,
                ComentariosTeachers: BoletaTemplateCfg.IdPlantilla == 2 ? boletaComentariosTeachers.join("\n") : "",
                ComentariosFinalesTeachers: "",
                ComentariosTutores: "",
                ComentariosFinalesTutores: "",
                SubjectTeachersRel: subjectsTeachersRel,
                CurrentGroupsIds: groupsIdsInReportCard,
                FinalGroupsIds: IsCurrentCicloEscolar ? groupsIdsInReportCard : [],
                NombreTutores: BoletaTemplateCfg.IdPlantilla == 2 ? tutorsNamesArr.join("\n") : "",
                NombreTutoresFinal: BoletasGeneradasEnCiclo.length == 2 ? (BoletaTemplateCfg.IdPlantilla == 2 ? tutorsNamesArr.join("\n") : "") : "",
                BoletaTemplateCfg: BoletaTemplateCfg,
                CurrentPeriodPos: BoletasGeneradasEnCiclo.length, // FIXME: Ahora se pueden generar boletas de un Periodo N sin que existan boletas de periodos anteriores
                IdBoletaParent: BoletasGeneradasEnCiclo.find(d => d.IdPadre == 0)?.IdBoletaGenerada || 0,
            }
        });
    }

    private PrepareStudentsDataList(): ItemAlumno[] {
        const manySchools = group(this.finalStudentsData, (d) => d.Alumno.IdKinder).size > 1;
        return this.finalStudentsData.map<ItemAlumno>(info => {
            const { Alumno, BoletaTemplateCfg, CurrentGroupsIds, CalificacionesFinal, CicloEscolar } = info;
            const usesSubjectsTeachers = BoletaTemplateCfg.Extras && (
                BoletaTemplateCfg.Extras.usaMateriaMaestro ||
                BoletaTemplateCfg.Extras.usaMateriaMaestroInformacionCabecera ||
                BoletaTemplateCfg.Extras.usaMateriaMaestroAsignaturasFirmas
            );

            let strDescripcion = "";

            if (Alumno.Matricula) {
                strDescripcion += `${_L("alumnos.d_field_matricula")}: ${Alumno.Matricula}\n`;
            }
            if (manySchools) {
                strDescripcion += `${_L("calificaciones.d_field_strescuela")}: ${Alumno.NombreKinder}`;
            }
            if (BoletaTemplateCfg.IdPlantilla == 2 && usesSubjectsTeachers) {
                let keyLocalStorageReportCard = `${DataUtil._Usuario.IdUsuario}_${Alumno.IdKinder}_${Alumno.IdEscolaridad}_${Alumno.IdGrado}_${CurrentGroupsIds.join(",")}`;
                UIUtilViewCalificacion.FixReportCardSubjectRelWithLocal(keyLocalStorageReportCard, info.SubjectTeachersRel)
                UIUtilViewCalificacion.UpdateLocalReportConfig(keyLocalStorageReportCard, info.SubjectTeachersRel);
            }
            const subjectsIds: number[] = [];
            const subjectsEvaluatorsIds: string[] = [];
            CalificacionesFinal.forEach(d => {
                subjectsIds.push(d.IdMateria)
                subjectsEvaluatorsIds.push(d.IdsTeachersEvaluantes.join(","));
            });

            this.studentsBoletasInfoMap.set(Alumno.IdChild, info);

            return {
                IdChild: Alumno.IdChild,
                IdEscuela: Alumno.KinderFiltro[0],
                NombreCompleto: Alumno.NombreCompleto,
                Selected: false,
                PDF: null,
                PDFStatus: UIUtilViewCalificacion.CPDFStatus.Pendiente,
                PDFFileName: _L("calificacion.boleta") + " " + UIUtilTime._GetValidatorDateYMD(new Date()) + " - " + Alumno.NombreCompleto + ".pdf",
                PageFocus: 1,
                AlumnoDescripcion: strDescripcion,
                IdsEval: info.IdsAllEvals,
                InfoBoletaFinal: info,
                InfoBoleta: {
                    TipoExpediente: Entidad.CTipoExpediente.Boleta,
                    Estado: 0,
                    IdPadreBoleta: info.IdBoletaParent,
                    IdCicloEscolar: info.CicloEscolar.Id,
                    IdNivel: Alumno.IdEscolaridad,
                    IdGrado: Alumno.IdGrado,
                    IdsGrupos: info.FinalGroupsIds,
                    IdsEvaluaciones: info.IdsAllEvals,
                    IdsMaterias: subjectsIds,
                    IdsEvaluadores: subjectsEvaluatorsIds,
                },
                VerificationCompleted: _IsCurrentCicloEscolar(CicloEscolar),
            }
        })
    }

    private StudentsListInit(parentContainer: TSelectionHTML<"div">) {
        this.ctrlList = new List<ItemAlumno>()
            ._SetParent(parentContainer.node())
            ._SetCreateTemplate((itemContainer) => {
                let lbl = itemContainer
                    .classed(UIUtilGeneral.FBoxOrientation.Horizontal, true)
                    .classed(UIUtilGeneral.FBoxAlign.SpacebetweenCenter, true)
                    .append("label")
                    .classed("item_lbl", true);

                let sentStatus = lbl.append("img")
                    .attr("id", "sentExp")
                    .attr("src", UIUtilIconResources.CGeneral.AcceptInCircle)
                    .attr("draggable", false)
                    .classed("hide", true)

                lbl.append("span")
                    .attr("id", "name");

                lbl.append("pre")
                    .attr("id", "description");

                const tooltipElement = itemContainer.append<HTMLTooltipComponent>("wc-tooltip").classed("tooltip_status", true).node();
                tooltipElement._SetObservedElementsAdvanced(
                    {
                        Target: sentStatus.node(),
                        Text: _L("calificacion.sent_as_expedient"),
                    }
                )
            })
            ._SetUpdateItem((itemContainer, d) => {
                itemContainer.select(":scope > .item_lbl > #sentExp").classed("hide", !d.SentExp);
                itemContainer.select(":scope > .item_lbl > #name").text(d.NombreCompleto);
                itemContainer.select(":scope > .item_lbl > #description").text(d.AlumnoDescripcion);

                itemContainer.on("click", async () => {
                    if (d.Selected) return;
                    if (!d.VerificationCompleted) this.ReportCardEditInfo(d);
                    this.studentsDataList.forEach(d => d.Selected = false);
                    d.Selected = true;
                    if (!d.PDF || d.PDFStatus == CPDFStatus.Pendiente) {
                        await this.BuildPDF(d);
                        return;
                    }

                    this.ctrlList._RefreshList();
                    PDFThings._PDFViewer(d.PDF, this.pdfViewerContainer.node(), {
                        changePageFocusCallback: (nPage) => { d.PageFocus = nPage },
                        nPageFocus: d.PageFocus,
                    });
                });

                if (!d.Selected) {
                    itemContainer.style("background-color", null)
                    itemContainer.select(".options").remove();
                    itemContainer.select(".tooltip_options").remove();
                    return;
                }

                if (itemContainer.select(".options").node()) return;

                itemContainer.style("background-color", "var(--color_primary2)");
                const optsContainer = itemContainer.append("div")
                    .attr("class", "options")
                    .classed(UIUtilGeneral.FBoxOrientation.Horizontal, true)
                    .classed(UIUtilGeneral.FBoxAlign.EndCenter, true)

                const tooltipElement = itemContainer.append<HTMLTooltipComponent>("wc-tooltip").classed("tooltip_options", true).node();
                tooltipElement._SetObservedElementsAdvanced(...this.GetTooltipOptions(d, optsContainer))
            })
            ._SetItems(this.studentsDataList);
    }

    private GetTooltipOptions(itemAlumno: ItemAlumno, optsContainer: TSelectionHTML<"div">): TooltipElementObservedConfig[] {
        const IsCurrentCicloEscolar = _IsCurrentCicloEscolar(itemAlumno.InfoBoletaFinal.CicloEscolar);
        const availableToEdit = (
            itemAlumno.InfoBoletaFinal.BoletaTemplateCfg.IdPlantilla != 2
            || !IsCurrentCicloEscolar
            || itemAlumno.InfoBoletaFinal.BoletaTemplateCfg.Extras.usaMateriaMaestro
            || itemAlumno.InfoBoletaFinal.BoletaTemplateCfg.Extras.usaMateriaMaestroInformacionCabecera
            || itemAlumno.InfoBoletaFinal.BoletaTemplateCfg.Extras.usaMateriaMaestroAsignaturasFirmas
        );

        const editionTooltipText = !availableToEdit
            ? `${_L("calificacion.edition_not_available_tooltip")}`
            : itemAlumno.InfoBoletaFinal.BoletaTemplateCfg.IdPlantilla == 2
                ? _L("boleta_v4.title_edit")
                : IsCurrentCicloEscolar
                    ? _L("boleta_v3.title_edit")
                    : _L("boleta_v3.title_general_edition");
        return [
            {
                Target: optsContainer.append("img")
                    .attr("class", "btn_round")
                    .attr("src", UIUtilIconResources.CGeneral.Editar)
                    .style("cursor", availableToEdit ? "unset" : "not-allowed")
                    .on("click", () => {
                        if (!availableToEdit) return;
                        this.ReportCardEditInfo(itemAlumno);
                    }).node(),
                HTMLBasic: editionTooltipText,
            },
            {
                Target: optsContainer.append("img")
                    .attr("class", "btn_round")
                    .attr("src", UIUtilIconResources.CGeneral.Print)
                    .on("click", () => {
                        this.ReportCardEvalVerification(itemAlumno, () => {
                            if (itemAlumno.SentExp) {
                                UIUtilViewCalificacion.printPDF(itemAlumno.PDF);
                                return;
                            }
                            this.modal.Modal._EscKeydownEnabled = false;
                            UIUtilViewCalificacion.SendBoletaAsExpediente([itemAlumno], () => {
                                this.ctrlList._RefreshList();
                                this.modal.Modal._EscKeydownEnabled = true;
                                UIUtilViewCalificacion.printPDF(itemAlumno.PDF);
                            })
                        });

                    }).node(),
                Text: _L("general.print")
            },
            {
                Target: optsContainer.append("img")
                    .attr("class", "btn_round")
                    .attr("src", UIUtilIconResources.CGeneral.Download)
                    .on("click", () => {
                        this.ReportCardEvalVerification(itemAlumno, () => {
                            if (itemAlumno.SentExp) {
                                saveAs(itemAlumno.PDF, itemAlumno.PDFFileName);
                                return;
                            }
                            this.modal.Modal._EscKeydownEnabled = false;
                            UIUtilViewCalificacion.SendBoletaAsExpediente([itemAlumno], () => {
                                this.ctrlList._RefreshList();
                                this.modal.Modal._EscKeydownEnabled = true;
                                saveAs(itemAlumno.PDF, itemAlumno.PDFFileName);
                            })
                        })
                    })
                    .node(),
                Text: _L("general.descargar")
            },
            {
                Target: optsContainer.append("img")
                    .attr("class", "btn_round")
                    .attr("src", UIUtilIconResources.CGeneral.Circular2)
                    .on("click", async () => {
                        this.ReportCardEvalVerification(itemAlumno, () => {
                            UIUtilViewCalificacion.OpenModal_EnviarTutor(itemAlumno, this.ctrlList);
                        })
                    })
                    .node(),
                Text: _L("calificacion.enviartutor")
            }
        ]
    }

    private GetBoletaDataAndConfig(idAlumno: number): IBoletaConfigV2 {
        const itemStudent = this.studentsDataList.find(d => d.IdChild == idAlumno);
        const studentBoletaDataInMap = this.studentsBoletasInfoMap.get(idAlumno);
        const {
            BoletasGeneradasEnCiclo = [],
            CicloEscolar,
            Inasistencias,
            ComentariosTeachers,
            ComentariosFinalesTeachers,
            ComentariosFinalesTutores,
            ComentariosTutores,
            NombreTutores,
            NombreTutoresFinal,
            Alumno,
            CurrentGroupsIds,
            BoletaTemplateCfg,
            CalificacionesFinal,
            InfoExtra,
            Comentario,
            SubjectTeachersRel,
            FinalGroupsIds

        } = studentBoletaDataInMap;
        const escuelaLogo = DataModuloMain._GetDataValueFieldByName("Escuela", Alumno.IdKinder, "Logo");

        if (BoletasGeneradasEnCiclo?.length) {
            BoletasGeneradasEnCiclo.sort((a, b) => ascending(a.FechaCreacion, b.FechaCreacion));
        }

        const periodsAbsences: number[] = [];
        const periodsTeachersComments: string[] = [];
        const periodsTutorsComments: string[] = [];
        const periodsTutorsNames: string[] = [];
        const periodsSubjectsAssignmentsEvals: IMateriaEvaluacion[][] = [];

        for (const { NInasistencias, Observaciones, IdsEvaluaciones, EvaluacionesIdAsignaciones, EvaluacionesValores, EvaluacionesFechas } of BoletasGeneradasEnCiclo) {
            periodsAbsences.push(NInasistencias);
            periodsTeachersComments.push(Observaciones?.[0] || "");
            periodsTutorsComments.push(Observaciones?.[2] || "");
            periodsTutorsNames.push(Observaciones?.[4] || "");

            const evaluationsInfo: IEvaluacionInfo[] = IdsEvaluaciones.map((_, iPos) => {
                const idAssignment = EvaluacionesIdAsignaciones[iPos];
                const assignmentInfo = this.assignmentsInfoMap.get(idAssignment);
                return {
                    IdEvaluacion: IdsEvaluaciones[iPos],
                    IdAsignacion: idAssignment,
                    EvalValor: EvaluacionesValores[iPos],
                    NombreCriterio: assignmentInfo.Criterio,
                    IdMateria: assignmentInfo.IdMateria,
                    TipoEval: assignmentInfo.TipoEval,
                    FechaEval: EvaluacionesFechas[iPos],
                }
            });

            const evaluationsGrouppedByAssignment = group(evaluationsInfo, d => d.IdAsignacion);

            const assignmentsEvals = Array.from(evaluationsGrouppedByAssignment.values()).map<UIUtilViewCalificacion.IAuxCalificacion>(assignmentEvals => {
                assignmentEvals.sort((a, b) => descending(a.IdEvaluacion, b.IdEvaluacion));
                assignmentEvals.sort((a, b) => descending(a.FechaEval, b.FechaEval));
                const { IdAsignacion, IdMateria, NombreCriterio, TipoEval, FechaEval } = assignmentEvals[0];
                return {
                    IdAsignacion: IdAsignacion,
                    IdMateria: IdMateria,
                    IdsEvaluaciones: assignmentEvals.map(d => d.IdEvaluacion),
                    NombreCriterio: NombreCriterio,
                    TipoEval: TipoEval,
                    EvalGral: [UIUtilViewCalificacion._GetEvalGral(assignmentEvals.map(d => d.EvalValor), TipoEval)[0]],
                    MaxDtEval: FechaEval,
                    MaxIdEval: [...assignmentEvals.map(d => d.IdEvaluacion)].sort((a, b) => b - a)[0],
                }
            });

            const assignmentsEvalsGrouppedBySubject = group(assignmentsEvals, d => d.IdMateria);
            const arrMateriasEvaluaciones: ISubjectAssignmentsEvals[] = Array.from(assignmentsEvalsGrouppedBySubject.values()).map<ISubjectAssignmentsEvals>(subjectAssignmentsEvals => {
                const { IdMateria, TipoEval, IdAsignacion, EvalGral, MaxDtEval, MaxIdEval, NombreCriterio } = subjectAssignmentsEvals[0];
                const subjectNoCriteria = subjectAssignmentsEvals.length == 1 && (!NombreCriterio || NombreCriterio == '');

                return {
                    IdMateria: IdMateria,
                    TipoEval: TipoEval,
                    TieneCriterios: !subjectNoCriteria,
                    Evaluaciones: subjectNoCriteria
                        ? [{ Id: null, IdAsignacion: IdAsignacion, Nombre: null, Evaluacion: EvalGral, Comentarios: null, MaxDtEval: MaxDtEval, MaxIdEval: MaxIdEval }]
                        : subjectAssignmentsEvals.map(d => ({ Id: null, IdAsignacion: d.IdAsignacion, Nombre: d.NombreCriterio, Evaluacion: d.EvalGral, Comentarios: null, MaxDtEval: d.MaxDtEval, MaxIdEval: d.MaxIdEval }))
                }
            })

            periodsSubjectsAssignmentsEvals.push(arrMateriasEvaluaciones);
        }

        periodsSubjectsAssignmentsEvals.push(CalificacionesFinal.map<IMateriaEvaluacion>(subjectsEvals => {
            const hasCriteria = subjectsEvals.Criterios.length > 0;
            return {
                IdMateria: subjectsEvals.IdMateria,
                TipoEval: subjectsEvals.TipoEval,
                TieneCriterios: hasCriteria,
                Evaluaciones: hasCriteria
                    ? subjectsEvals.Criterios.map<IEvaluacionesV2>(d => ({ Id: null, IdAsignacion: d.IdAsignacion, Nombre: d.Criterio, Evaluacion: d.EvaluacionArr, Comentarios: null, MaxDtEval: d.MaxDtEval, MaxIdEval: d.MaxIdEval }))
                    : [{ Id: null, IdAsignacion: subjectsEvals.IdAsignacion, Nombre: subjectsEvals.StrMateria, Evaluacion: subjectsEvals.Evaluacion, Comentarios: null, MaxDtEval: subjectsEvals.MaxDtEval, MaxIdEval: subjectsEvals.MaxIdEval }]

            }
        }))

        periodsTeachersComments.push(ComentariosTeachers);
        periodsTutorsComments.push(ComentariosTutores);
        periodsTutorsNames.push(NombreTutores)
        periodsAbsences.push(Inasistencias);

        periodsTeachersComments[3] = ComentariosFinalesTeachers;
        periodsTutorsComments[3] = ComentariosFinalesTutores;
        periodsTutorsNames[3] = NombreTutoresFinal;

        const subjectsQualifications: ICalificacionInfoAPeriods[] = [];
        periodsSubjectsAssignmentsEvals.forEach((periodSubjectsAssignmentsEvals, iPos) => {
            periodSubjectsAssignmentsEvals.forEach(subject => {
                let subjectQualifs = subjectsQualifications.find(d => d.IdMateria == subject.IdMateria);
                const { Nombre = "No Disponible", EvalValor = [], EvalDescripcion = [] } = _DiccMateriasV2.get(subject.IdMateria) || {};
                const subjectHasNotCriteria = !subject.TieneCriterios;
                if (!subjectQualifs) {
                    subjectsQualifications.push({
                        IdMateria: subject.IdMateria,
                        MateriaNombre: Nombre,
                        TipoEval: subject.TipoEval,
                        EvalValor: EvalValor,
                        EvalDescripcion: EvalDescripcion,
                        TieneCriterios: !subjectHasNotCriteria,
                        Evaluaciones: []
                    })
                }
                subjectQualifs = subjectsQualifications.find(d => d.IdMateria == subject.IdMateria);
                subject.Evaluaciones.forEach(evalAssignment => {
                    let asigEvalsP = subjectQualifs.Evaluaciones.find(d => d.IdAsignacion == evalAssignment.IdAsignacion);

                    if (!asigEvalsP) {
                        subjectQualifs.Evaluaciones.push({ IdAsignacion: evalAssignment.IdAsignacion, Nombre: subjectHasNotCriteria ? Nombre : evalAssignment.Nombre, Evaluaciones: [], MaxDtsEvals: [], MaxIdsEvals: [] });
                    }
                    asigEvalsP = subjectQualifs.Evaluaciones.find(d => d.IdAsignacion == evalAssignment.IdAsignacion);
                    asigEvalsP.Evaluaciones[iPos] = evalAssignment.Evaluacion || [];
                    asigEvalsP.MaxDtsEvals[iPos] = evalAssignment.MaxDtEval || "";
                    asigEvalsP.MaxIdsEvals[iPos] = evalAssignment.MaxIdEval;
                })
            })
        })

        subjectsQualifications
            .sort((a, b) => ascending(a.MateriaNombre, b.MateriaNombre))
            .sort((a, b) => ascending((a.TipoEval == CTipoEvaluacion.Numeros ? -1 : a.TipoEval), (b.TipoEval == CTipoEvaluacion.Numeros ? -1 : b.TipoEval)))

        subjectsQualifications.forEach(materia => {
            const CriteriosMaterias = _DiccMateriasV2.get(materia.IdMateria)?.Criterios || [];
            const HasCriteriasConfig = CriteriosMaterias.length > 0;
            const criteriasOrder = {};
            if (HasCriteriasConfig) {
                CriteriosMaterias.forEach((criterio, iPos) => {
                    criteriasOrder[criterio] = iPos;
                })
            }
            materia.Evaluaciones.forEach(asignacionEval => {
                const AsignacionCalifs: string[] = [];
                asignacionEval.Evaluaciones.forEach(evalAsig => { if (evalAsig) AsignacionCalifs.push(...evalAsig) })
                asignacionEval.Evaluaciones[3] = [UIUtilViewCalificacion._GetEvalGral(AsignacionCalifs, materia.TipoEval).reverse()[0]]; // NOTE: PUEDE TRATARSE COMO 3 O + DEPENDIENDO DE EL TAMAÑO DE PERIODOS POSIBLES
            })

            materia.Evaluaciones
                .sort((a, b) => ascending(a.IdAsignacion, b.IdAsignacion))
                .sort((a, b) => ascending(criteriasOrder[a.Nombre], criteriasOrder[b.Nombre]))
        })

        subjectsQualifications.forEach(d => {
            d.Evaluaciones.forEach(asigEvals => {
                for (let index = 0; index < 3; index++) {
                    asigEvals.Evaluaciones[index] = asigEvals.Evaluaciones[index] || []
                    asigEvals.MaxDtsEvals[index] = asigEvals.MaxDtsEvals[index] || "";
                    asigEvals.MaxIdsEvals[index] = asigEvals.MaxIdsEvals[index] || 0;
                }
            });
        })

        let groupsNames: string[] = [];
        let gradesNames: string[] = [];
        let levelsNames: string[] = [];
        const isCurrentCicloEscolar = _IsCurrentCicloEscolar(CicloEscolar);

        if (!isCurrentCicloEscolar) {
            groupsNames = _GetBoletaGroupsName(FinalGroupsIds);
            gradesNames = _GetBoletaGrados(FinalGroupsIds, studentBoletaDataInMap).map(d => d.Nombre);
            levelsNames = _GetBoletaNiveles(FinalGroupsIds, studentBoletaDataInMap).map(d => d.Nombre);
        } else {
            groupsNames = _GetStudentGroupsName(Alumno.IdChild);
            gradesNames = [Alumno.StrGrado];
            levelsNames = [Alumno.StrEscolaridad];
        }

        return {
            Titulo: _L("boleta_v2.evaluacion"),
            Logo: escuelaLogo,
            NombreAlumno: Alumno.NombreCompleto,
            FechaNacimiento: UIUtilTime._DateFormatStandar(Alumno.FechaNacimiento),
            IdEscuela: Alumno.IdKinder,
            Grupos: groupsNames.join(", "),
            CurrentGroupsIds: CurrentGroupsIds,
            FinalGroupsIds: FinalGroupsIds,
            Grado: gradesNames.join(", "),
            Nivel: levelsNames.join(", "),
            CicloEscolar: CicloEscolar.Nombre,
            Fecha: UIUtilTime._DateFormatStandar(new Date()),
            Comentario: Comentario,
            InfoExtra: InfoExtra,
            InasistenciasCurrentPeriod: Inasistencias,
            InasistenciasAllPeriods: periodsAbsences,
            MetadataTitle: itemStudent.PDFFileName,
            BoletasEnCiclo: BoletasGeneradasEnCiclo,
            BoletaActualPosition: BoletasGeneradasEnCiclo?.length || 0,
            BoletaCfgTemplate: BoletaTemplateCfg,
            TeachersComments: ComentariosTeachers,
            TeachersCommentsAllPeriods: periodsTeachersComments,
            TutoresCommentsAllPeriods: periodsTutorsComments,
            TutoresNamesAllPeriods: periodsTutorsNames,
            MateriasTeachersRel: SubjectTeachersRel,
            MateriasCalificacionesAllPeriods: subjectsQualifications,
            MateriasCurrentCalificaciones: CalificacionesFinal.map<ICalificacionInfoV2>(materiaCal => {
                const tieneCriterios = materiaCal.Criterios.length > 0;
                const criteriasOrder = {};
                if (tieneCriterios) {
                    materiaCal.Criterios[0].Criterios.forEach((criterio, iPos) => {
                        criteriasOrder[criterio] = iPos;
                    })
                }
                return {
                    IdMateria: materiaCal.IdMateria,
                    MateriaNombre: materiaCal.StrMateria,
                    TipoEval: materiaCal.TipoEval,
                    EvalValor: materiaCal.ValNombres,
                    EvalDescripcion: materiaCal.ValDescripcion,
                    MinimoAprobatorio: materiaCal.MinimoAprobatorio,
                    TieneCriterios: tieneCriterios,
                    IdEvaluadores: materiaCal.IdsTeachersEvaluantes,
                    Evaluaciones: tieneCriterios
                        ? materiaCal.Criterios.map(d => ({
                            Id: UIUtilViewCalificacion.GetId("criterio", d),
                            IdAsignacion: d.IdAsignacion,
                            Nombre: d.Criterio,
                            Evaluacion: d.EvaluacionArr,
                            Comentarios: (() => {
                                let msg = d.Observaciones.filter(o => !!o.trim()).join('. ');
                                return msg;
                            })(),
                            MaxDtEval: d.MaxDtEval,
                            MaxIdEval: d.MaxIdEval
                        }))
                            .sort((a, b) => ascending(a.Id, b.Id))
                            .sort((a, b) => ascending(criteriasOrder[a.Nombre], criteriasOrder[b.Nombre]))
                        : [{
                            Id: UIUtilViewCalificacion.GetId("materia", materiaCal),
                            IdAsignacion: materiaCal.IdAsignacion,
                            Nombre: materiaCal.StrMateria,
                            Evaluacion: materiaCal.Evaluacion,
                            Comentarios: materiaCal.ComentariosMateria,
                            MaxDtEval: materiaCal.MaxDtEval,
                            MaxIdEval: materiaCal.MaxIdEval
                        }]
                }
            })
                .sort((a, b) => ascending(a.MateriaNombre, b.MateriaNombre))
                .sort((a, b) => ascending((a.TipoEval == CTipoEvaluacion.Numeros ? -1 : a.TipoEval), (b.TipoEval == CTipoEvaluacion.Numeros ? -1 : b.TipoEval))),
        }
    }

    private async BuildPDF(itemAlumno: ItemAlumno) {
        if (itemAlumno.PDF != null && itemAlumno.PDFStatus == CPDFStatus.Construido) return;

        this.modal.Progress.attr("oculto", false);
        let pdf = await this.GetPDFBuilded(itemAlumno);
        itemAlumno.PDF = pdf;
        itemAlumno.PDFStatus = !pdf ? CPDFStatus.Pendiente : CPDFStatus.Construido;
        this.modal.Progress.attr("oculto", true);
        if (itemAlumno.Selected) {
            this.ctrlList._RefreshList();
            PDFThings._PDFViewer(itemAlumno.PDF, this.pdfViewerContainer.node(), {
                changePageFocusCallback: (nPage) => { itemAlumno.PageFocus = nPage },
                nPageFocus: itemAlumno.PageFocus,
            })
        }
    }

    private async GetPDFBuilded(itemAlumno: ItemAlumno): Promise<File> {
        const reportCfg = this.GetBoletaDataAndConfig(itemAlumno.IdChild);
        const pdfDocument = reportCfg.BoletaCfgTemplate.IdPlantilla == 2
            ? await _BoletaPDFV4_1(reportCfg)
            : await _BoletaPDFV3(reportCfg);

        return new File([pdfDocument.output("blob")], "Boleta")
    }

    private async BuildAndDownloadAllPDF() {
        const resultFolderName = `${_L("calificacion.boleta_title")} ${UIUtilTime._GetValidatorDateYMD(new Date())}`;
        const zip = new JSZip();
        const resumeFolder = zip.folder(resultFolderName);
        this.modal.Progress.attr("oculto", false);
        for (const itemStudent of this.studentsDataList) {
            await this.BuildPDF(itemStudent);
            let blob = itemStudent.PDF
            resumeFolder.file(itemStudent.PDFFileName, blob);
        }
        zip.generateAsync({ type: "blob" })
            .then((content) => {
                saveAs(content, resultFolderName);
            })
            .catch((e) => {
                DataUtilAlertBot._SendError(e, "Reporte Boleta calificaciones");
                NotificacionV2._Mostrar(_L("general.notif_fail"), "ADVERTENCIA");
            })
            .finally(() => {
                this.modal.Progress.attr("oculto", true);
            })
    }

    private ReportCardEditInfo(itemAlumno: ItemAlumno, onVerificated?: () => void) {
        const boletaInfo = this.studentsBoletasInfoMap.get(itemAlumno.IdChild);
        const { BoletaTemplateCfg } = boletaInfo;

        switch (BoletaTemplateCfg.IdPlantilla) {
            case 2:
                _ModalEditionBoletaV4_1(boletaInfo, async (changedTeachersRel) => {
                    if (boletaInfo.FinalGroupsIds?.length) {
                        itemAlumno.VerificationCompleted = true;
                    }
                    itemAlumno.PDFStatus = CPDFStatus.Pendiente;
                    itemAlumno.PDF = null;

                    if (!_IsCurrentCicloEscolar(boletaInfo.CicloEscolar)) {
                        itemAlumno.InfoBoleta.IdNivel = _GetBoletaNiveles(boletaInfo.FinalGroupsIds, boletaInfo)[0]?.Id;
                        itemAlumno.InfoBoleta.IdGrado = _GetBoletaFilteredGrades(boletaInfo.FinalGroupsIds, itemAlumno.InfoBoleta.IdNivel, boletaInfo)[0]?.IdNivel;
                        itemAlumno.InfoBoleta.IdsGrupos = _GetBoletaFilteredGroups(boletaInfo.FinalGroupsIds, itemAlumno.InfoBoleta.IdGrado, boletaInfo).map(d => d.IdGrupo);
                    }
                    if (onVerificated && itemAlumno.VerificationCompleted) {
                        await this.BuildPDF(itemAlumno);
                        onVerificated();
                    } else {
                        this.BuildPDF(itemAlumno);
                    }

                    if (!changedTeachersRel) return;
                    const keyLocalStorageReportCard = `${DataUtil._Usuario.IdUsuario}_${boletaInfo.Alumno.IdKinder}_${boletaInfo.Alumno.IdEscolaridad}_${boletaInfo.Alumno.IdGrado}_${boletaInfo.CurrentGroupsIds.join(",")}`;
                    UIUtilViewCalificacion.UpdateLocalReportConfig(keyLocalStorageReportCard, boletaInfo.SubjectTeachersRel);
                    let alumnosSameKeyInReportCard = this.finalStudentsData.filter(({ Alumno, CurrentGroupsIds }) =>
                        `${DataUtil._Usuario.IdUsuario}_${Alumno.IdKinder}_${Alumno.IdEscolaridad}_${Alumno.IdGrado}_${CurrentGroupsIds.join(",")}` == keyLocalStorageReportCard
                        && Alumno.IdChild !== itemAlumno.IdChild
                    );
                    if (!alumnosSameKeyInReportCard.length) return;
                    this.modal.Modal._EscKeydownEnabled = false;
                    let resApplySubjectTeachersRel = await UIUtilViewCalificacion.OpenModalExtendSubjectTeachersRel(alumnosSameKeyInReportCard);
                    this.modal.Modal._EscKeydownEnabled = true;
                    if (!resApplySubjectTeachersRel) return;
                    alumnosSameKeyInReportCard.forEach(({ SubjectTeachersRel, Alumno }) => {
                        UIUtilViewCalificacion.FixReportCardSubjectRelWithLocal(keyLocalStorageReportCard, SubjectTeachersRel);
                        UIUtilViewCalificacion.ResetPdfItem(this.studentsDataList, Alumno.IdChild)
                    });
                })
                break;
            default:
                _ModalEditionBoletaV3(boletaInfo, async () => {
                    if (boletaInfo.FinalGroupsIds?.length) {
                        itemAlumno.VerificationCompleted = true;
                    }
                    itemAlumno.PDFStatus = CPDFStatus.Pendiente;
                    itemAlumno.PDF = null;
                    if (!_IsCurrentCicloEscolar(boletaInfo.CicloEscolar)) {
                        itemAlumno.InfoBoleta.IdNivel = _GetBoletaNiveles(boletaInfo.FinalGroupsIds, boletaInfo)[0]?.Id;
                        itemAlumno.InfoBoleta.IdGrado = _GetBoletaFilteredGrades(boletaInfo.FinalGroupsIds, itemAlumno.InfoBoleta.IdNivel, boletaInfo)[0]?.IdNivel;
                        itemAlumno.InfoBoleta.IdsGrupos = _GetBoletaFilteredGroups(boletaInfo.FinalGroupsIds, itemAlumno.InfoBoleta.IdGrado, boletaInfo).map(d => d.IdGrupo);
                    }
                    if (onVerificated && itemAlumno.VerificationCompleted) {
                        await this.BuildPDF(itemAlumno);
                        onVerificated();
                    } else {
                        this.BuildPDF(itemAlumno);
                    }
                })
                break;
        }
        return;
    }

    private ReportCardEvalVerification(itemAlumno: ItemAlumno, onVerificated: () => void) {
        if (itemAlumno.VerificationCompleted) {
            onVerificated && onVerificated();
            return;
        }

        NotificacionV2._Mostrar(_L("calificacion.notif_complete_scolarship_info"), "ADVERTENCIA")
        this.ReportCardEditInfo(itemAlumno, onVerificated);
    }

    private ReportCardEvalVerificationMulti() {
        const arrErrVerificationCompleted: ItemAlumno[] = [];
        for (const itemAlumno of this.studentsDataList) {
            if (!itemAlumno.VerificationCompleted) {
                arrErrVerificationCompleted.push(itemAlumno);
            }
        }
        if (!arrErrVerificationCompleted.length) return true;
        _ModalInfoDataList({
            Title: _L("calificacion.pending_scolarship_verification"),
            InfoText: `${_L("calificacion.pending_scolarship_verification_info")}:`,
            DataList: arrErrVerificationCompleted,
            OnStepItemData: (content, item) => {
                content.text(`${item.NombreCompleto}`)
            }
        })
        return false;
    }

    public ShowModal() {
        this.modal = _ModalToAProccess({
            Title: _L("calificacion.generarboleta_title"),
            Width: 1000,
            Height: "800px",
            DrawContent: (container) => {
                container.classed(UIUtilGeneral.FBoxOrientation.Horizontal, true).classed("boletas_generator", true);
                let divPadre = container.append("div");
                divPadre.classed("lateral_parent", true);

                this.StudentsListInit(divPadre);

                let divButtons = divPadre.append("div").classed("main_buttons", true);
                new Button(divButtons.node(), _L("general.descargartodo"))
                    ._d3Selection
                    .on("click", async () => {
                        if (!this.ReportCardEvalVerificationMulti()) return;
                        if (this.studentsDataList.every(d => d.SentExp)) {
                            this.BuildAndDownloadAllPDF();
                            return;
                        }

                        this.modal.Modal._EscKeydownEnabled = false;
                        this.modal.Progress.attr("oculto", false);
                        for (const studentItem of this.studentsDataList) {
                            await this.BuildPDF(studentItem);
                        }
                        this.modal.Progress.attr("oculto", false);
                        UIUtilViewCalificacion.SendBoletaAsExpediente(this.studentsDataList.filter(d => !d.SentExp), () => {
                            this.ctrlList._RefreshList();
                            this.modal.Modal._EscKeydownEnabled = true;
                            this.BuildAndDownloadAllPDF();
                        });
                    });

                let btnSendTutors = new Button(divButtons.node(), _L("calificacion.enviartutores"));
                btnSendTutors
                    ._d3Selection
                    .on("click", async () => {
                        if (!btnSendTutors._enabled) return;
                        if (!this.ReportCardEvalVerificationMulti()) return;
                        btnSendTutors._enabled = false;
                        this.modal.Progress.attr("oculto", false);
                        this.modal.Modal._DeshabilitarBtns();
                        let arrErr: ItemAlumno[] = [];
                        for (const itemAlumno of this.studentsDataList) {
                            await this.BuildPDF(itemAlumno);
                            if (!itemAlumno.PDF || itemAlumno.PDFStatus != CPDFStatus.Construido) {
                                arrErr.push(itemAlumno);
                                btnSendTutors._enabled = true;
                                return;
                            }
                        }

                        if (arrErr.length) {
                            NotificacionV2._Mostrar(_L("calificacion.pdf_fail_construct"), "ADVERTENCIA");
                            this.modal.Progress.attr("oculto", true);
                            this.modal.Modal._HabilitarBtns();
                            btnSendTutors._enabled = true;
                            return;
                        }

                        let messageCircular: string = "";
                        _ModalServiceIteratorBasic({
                            Title: _L("calificacion.title_confirm_envio"),
                            Message: _L("calificacion.optional_mssg"),
                            Width: 440,
                            DataToProccess: this.studentsDataList,
                            TypeRequest: null,
                            OnDrawContent: (content) => {
                                content.append("br");
                                let inputMssg = content.append("textarea").style("margin-top", "var(--padding2)").node();
                                inputMssg.oninput = e => {
                                    messageCircular = inputMssg.value;
                                }
                                if (!this.studentsDataList.every(d => d.SentExp)) {
                                    content.append("b").text(_L("calificacion.adv_boletastoexp")).style("font-size", "var(--fontsize_me2)");
                                }
                            },
                            OnStepAProccess: async (item) => {
                                const iBoleta = item.InfoBoleta;
                                let blob = item.PDF;
                                let errExp: string;
                                if (!item.SentExp) {
                                    let newExpRes = await _SvAlumnoNuevoExpedienteBoleta({
                                        IdAlumno: item.IdChild,
                                        IdEscuela: item.IdEscuela,
                                        IdCicloEscolar: iBoleta.IdCicloEscolar,
                                        IdNivel: iBoleta.IdNivel,
                                        IdGrado: iBoleta.IdGrado,
                                        IdsGrupos: item.InfoBoletaFinal.FinalGroupsIds,
                                        IdPadreBoleta: iBoleta.IdPadreBoleta,
                                        IdsMaterias: iBoleta.IdsMaterias,
                                        IdsEvaluadores: iBoleta.IdsEvaluadores,
                                        IdsEvaluaciones: iBoleta.IdsEvaluaciones,
                                        TipoExpediente: iBoleta.TipoExpediente,
                                        Estado: iBoleta.Estado,
                                        NInasistencias: item.InfoBoletaFinal.Inasistencias,
                                        ObservacionTeachers: item.InfoBoletaFinal.ComentariosTeachers,
                                        ObservacionTeachersFinal: item.InfoBoletaFinal.ComentariosFinalesTeachers,
                                        ComentarioTutores: item.InfoBoletaFinal.ComentariosTutores,
                                        ComentarioTutoresFinal: item.InfoBoletaFinal.ComentariosFinalesTutores,
                                        NombreTutores: item.InfoBoletaFinal.NombreTutores,
                                        NombreTutoresFinal: item.InfoBoletaFinal.NombreTutoresFinal,
                                        Archivo: { File: item.PDF, Nombre: item.PDFFileName }
                                    })
                                    if (newExpRes.Resultado > 0) item.SentExp = true;
                                    else errExp = _L("calificacion.envio_expediente");
                                    this.ctrlList._RefreshList();
                                }

                                let resCircular = await _SvNoticiaNueva("ByAlumnos", <IMapSendCincularItems["ByAlumnos"]>{
                                    IdEscuela: item.IdEscuela,
                                    Titulo: _L("calificacion.boleta") + " " + UIUtilTime._GetValidatorDateYMD(new Date()) + " - " + item.NombreCompleto,
                                    Mensaje: messageCircular,
                                    Archivo: new File([blob], item.PDFFileName, { type: blob.type }),
                                    Programado: null,
                                    ReqAutorizacion: false,
                                    IdAlumnos: [item.IdChild]
                                });

                                if (resCircular.Resultado < 1 || errExp) {
                                    let msg = "";
                                    if (errExp) msg += errExp;
                                    if (errExp && resCircular.Resultado < 1) msg += " - ";
                                    if (resCircular.Resultado < 1) msg += _L("calificacion.envio_circular");

                                    resCircular.Resultado = -1.33;
                                    resCircular.Mensaje = msg
                                }

                                return resCircular;
                            },
                            OnError_GetItemDataTag: (d) => {
                                return `${d.NombreCompleto}`;
                            }
                        }).then(() => {
                            btnSendTutors._enabled = true;
                        }).catch((err) => null);
                        this.modal.Progress.attr("oculto", true);
                        this.modal.Modal._HabilitarBtns();
                    })

                this.pdfViewerContainer = container.append("div").classed("pdf_viewer", true);
            },
            OnClose: () => {
                this.config.onClose && this.config.onClose();
            },
        })

        if (this.studentsBoletasInfoMap.size == 1) {
            let student = this.studentsDataList[0];
            student.Selected = true;
            if (!student.VerificationCompleted) {
                this.ReportCardEditInfo(student);
            }
            this.BuildPDF(student);
        }
    }
}

export function _GenerarBoletasModal(config: IGenerateBoletasConfig) {
    const manager = new BoletasGeneratorManager(config);
    manager.ShowModal();
}
